import WorkScheduleTable from "../../../shared/work-schedule/WorkScheduleTable";

export default function SupervisorWorkSchedule() {
  return (
    <WorkScheduleTable
      title="Графік супервайзерів"
      scheduleEndpoint="/statistic/supervisor-schedule/"
      usersEndpoint="/user/supervisors/"
    />
  );
}

